import React from 'react'
import { dataBlock1, dataBlock2, dataBlock3, datas, dataAddress } from './footer_mock'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLocationDot, faPhone } from '@fortawesome/free-solid-svg-icons'
import { FaFacebookF } from 'react-icons/fa'
import { AiFillInstagram, AiOutlineTwitter, AiTwotoneMail } from 'react-icons/ai'
import '../../assets/styles/scss/common/_footer.scss'
import { Col, Row, Collapse } from 'antd'
import redcrossLogo from '../../assets/images/home/redcross.png'
import { useSetRecoilState } from 'recoil'
import { isLoadingState } from '../../recoil/states/default'
import axiosRc from '../../config/axios-rc'

const FooterHome = () => {
    const isMobile = window.innerWidth <= 992
    const { Panel } = Collapse;
    const setIsLoading = useSetRecoilState(isLoadingState)

    const listFooter = (data) => {
        return (
            data.map((item, index) => {
                return (
                    <li key={index}>
                        {
                            item.url?.includes('#') ? <span style={{ fontSize: '12px' }}>{item.label}</span> :
                                <a href={item.url} target={'_blank'} rel="noreferrer">{item.label}</a>
                        }

                        {item.children ?
                            <ul>
                                {item.children.map((child, c_index) => {
                                    return (
                                        <li key={index + c_index}>
                                            {
                                                child.url?.includes('#') ? <span style={{ fontSize: '12px' }}>{child.label}</span> :
                                                    <a href={child.url} target={'_blank'} rel="noreferrer">{child.label}</a>
                                            }
                                        </li>
                                    )
                                })}
                            </ul>
                            : null}
                    </li>
                )
            })
        )
    }

    const FooterMobile = () => {
        return (
            <Collapse ghost>
                <Panel className="text-head" header='ภารกิจกาชาดและงานสนับสนุนกลาง' key='1'>
                    {
                        listFooter(datas)
                    }
                </Panel>
                <Panel className="text-head" header={'บริการทางการแพทย์'} key={'2'}>
                    {
                        listFooter(dataBlock1)
                    }
                </Panel>
                <Panel className="text-head" header={'บริการโลหิต อวัยวะ และ ผลิตภัณฑ์ชีววัตถุ'} key={'3'}>
                    {
                        listFooter(dataBlock2)
                    }
                </Panel>
                <Panel className="text-head" header={'ภารกิจอื่น ๆ'} key={'4'}>
                    {
                        listFooter(dataBlock3)
                    }
                </Panel>
                <Panel className="text-head other-doc" header={'เอกสารอื่น ๆ'} key={'5'}>
                    <div className='cursor-pointer other-doc-list' onClick={handleDownloadOtherDoc}>แบบฟอร์มหนังสือรับรองให้มาสมัครงาน</div>
                </Panel>
            </Collapse >
        )
    }

    const handleDownloadOtherDoc = async () => {
        console.log('handleDownloadOtherDoc')
        setIsLoading(true)
        try {
            const res = await axiosRc.get("jobList/export_other_doc")
            if (res && res.data && res.data.length > 0) {
                window.location.href = res.request.responseURL
                setIsLoading(false)
            } else {
                setIsLoading(false)
            }
        } catch (error) {
            console.log('handleDownloadOtherDoc error =>', error)
            setIsLoading(false)
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div className='footer-sector relative'>
            <div className="image-banner absolute h-full right-0">
                <img alt='redcross' className='h-full' src={redcrossLogo} />
            </div>
            <div className='footer-layout container margin-auto h-full relative'>
                <div className="w-full footer-content">
                    <Row className={`w-full`}>
                        <Col xs={24} md={12} className='px-2 mb-3 w-full footer-l'>
                            <div className="title">หน่วยงานภายใน</div>
                            {
                                isMobile ?
                                    <FooterMobile /> :
                                    <Row className='footer-l-content'>
                                        <Col xs={24} md={12} className='children-footer-l-l'>
                                            <div className="text-head">ภารกิจกาชาดและงานสนับสนุนกลาง</div>
                                            {
                                                listFooter(datas)
                                            }
                                        </Col>
                                        <Col xs={24} md={12} className='children-footer-l-r'>
                                            <div className="block">
                                                <div className="text-head">บริการทางการแพทย์</div>
                                                {
                                                    listFooter(dataBlock1)
                                                }
                                            </div>
                                            <div className="block">
                                                <div className="text-head">บริการโลหิต อวัยวะ และ ผลิตภัณฑ์ชีววัตถุ</div>
                                                {
                                                    listFooter(dataBlock2)
                                                }
                                            </div>
                                            <div className="block other-mission">
                                                <div className="text-head">ภารกิจอื่น ๆ</div>
                                                {
                                                    listFooter(dataBlock3)
                                                }
                                            </div>
                                            <div className="block other-doc">
                                                <div className="text-head">เอกสารอื่น ๆ</div>
                                                <div className='cursor-pointer other-doc-list' onClick={handleDownloadOtherDoc}>แบบฟอร์มหนังสือรับรองให้มาสมัครงาน</div>
                                            </div>
                                        </Col>
                                    </Row>
                            }

                        </Col>
                        <Col xs={24} md={12} className='px-2 mb-3 w-full footer-r'>
                            <div className="title">ติดต่อ</div>
                            <div className="footer-r-content">
                                <div className="div-address mt-4">
                                    <div className="address text-address">
                                        <FontAwesomeIcon icon={faLocationDot} className='fa-location' />
                                        {dataAddress.address}
                                    </div>
                                    <div className="address-2 text-address">
                                        {dataAddress.district}&nbsp;{dataAddress.subDistrict}&nbsp;
                                        {dataAddress.province}&nbsp;{dataAddress.postCode}
                                    </div>
                                </div>
                                <div className="div-email mt-4">
                                    <a href={`mailto:${dataAddress.email}`} className='text-address flex items-center'>
                                        <AiTwotoneMail />
                                        {dataAddress.email}
                                    </a>
                                </div>
                                <div className="div-phone mt-4 text-address flex">
                                    <FontAwesomeIcon icon={faPhone} className='fa-phone' />
                                    <div>
                                        {/* <div className='text-address'>{dataAddress.telephone}</div>
                                        <div className='text-address'>{dataAddress.telephone2}</div> */}
                                        <div className='text-address'>{dataAddress.newAddress[0]}</div>
                                        <div className='text-address'>{dataAddress.newAddress[1]}</div>
                                        <div className='text-address'>{dataAddress.newAddress[2]}</div>
                                        <div className='text-address'>{dataAddress.newAddress[3]}</div>
                                        <div className='text-address'>{dataAddress.newAddress[4]}</div>
                                        <div className='text-address'>{dataAddress.newAddress[5]}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="footer-r-footer flex">
                                {
                                    dataAddress.facebook ?
                                        <a href={`${dataAddress.facebook}`} className='text-address' target='_blank' rel="noreferrer">
                                            <FaFacebookF />
                                        </a> :
                                        <div className='footer-icon cursor-default'>
                                            <FaFacebookF />
                                        </div>
                                }

                                {
                                    dataAddress.ig ?
                                        <a href={`${dataAddress.ig}`} className='text-address' target='_blank' rel="noreferrer">
                                            <AiFillInstagram />
                                        </a> :
                                        <div className='footer-icon'>
                                            <AiFillInstagram />
                                        </div>
                                }
                                {
                                    dataAddress.email ?
                                        <a href={`mailto:${dataAddress.email}`} className='text-address'>
                                            <AiTwotoneMail />
                                        </a> :
                                        <div className="footer-icon">
                                            <AiTwotoneMail />
                                        </div>
                                }
                                {
                                    dataAddress.twitter ?
                                        <a href={`${dataAddress.twitter}`} className='text-address' target='_blank' rel="noreferrer">
                                            <AiOutlineTwitter />
                                        </a> :
                                        <div className="footer-icon">
                                            <AiOutlineTwitter />
                                        </div>
                                }
                            </div>
                        </Col>
                    </Row>
                </div>
                {/* สงวนลิขสิทธิ์ โดย สภากาชาดไทย | นโยบายการคุ้มครองข้อมูลส่วนบุคคล | นโยบายคุกกี้ | ข้อตกลงการใช้งาน | มาตรการรักษาความมั่นคงปลอดภัยข้อมูลส่วนบุคคล */}
                <div className="copy-right text-center  margin-auto w-full flex justify-center">
                    <div>สงวนลิขสิทธิ์ โดย สภากาชาดไทย&nbsp;|&nbsp;</div>
                    <div>
                        <a href={`https://www.redcross.or.th/trcs-pdpa/`} target='_blank' rel="noreferrer">
                            นโยบายการคุ้มครองข้อมูลส่วนบุคคล
                        </a>
                    </div>
                    <div>&nbsp;|&nbsp;</div>
                    <div >
                        <a href={`https://www.redcross.or.th/cookie-policy/`} target='_blank' rel="noreferrer">
                            นโยบายคุกกี้
                        </a>
                    </div>
                    <div>&nbsp;|&nbsp;</div>
                    <div className="cursor-pointer">
                        <a href={`https://www.redcross.or.th/terms-of-use`} target='_blank' rel="noreferrer">
                            ข้อตกลงการใช้งาน
                        </a>
                    </div>
                    <div>&nbsp;|&nbsp;</div>
                    <div className="cursor-pointer">
                        <a href={`https://redcross.or.th/trcs-privacy-safeguard`} target='_blank' rel="noreferrer">
                            มาตรการรักษาความมั่นคงปลอดภัยข้อมูลส่วนบุคคล
                        </a>
                    </div>
                    {/* <div className="copy-right-l text-copy-right">Red Cross ©2023 All right reserved&nbsp;</div>
                    <div className="copy-right-r text-copy-right">|&nbsp;THAILAND RED CROSS</div> */}
                </div>
            </div>
        </div>
    )
}

export default FooterHome